import { cloneDeep } from 'lodash';


const IGNORED_QUERY_PARAMS = ['partials', 'edit_off'];


/**
 * Create endpoint urls for fetching and storing
 */
export function createFetchAndStoreUrls(store, compileFn, fetchUrl, params, query) {
    return [
        compileFn(fetchUrl, params, filterQueryParams(query, store)),
        compileFn(fetchUrl, params, removeQueryParams(query)),
    ];
}

/**
 * Filter query params for djangoCMS static placeholders
 */
function filterQueryParams(query = {}, store) {
    const result = Object.assign({ partials: [] }, cloneDeep(query));

    result.partials = result.partials.filter((name) => {
        return !store.getters.router.partials[name];
    });

    if (result.partials.length === 0) {
        delete result.partials;
    }

    return result;
}

/**
 * Filter query params for djangoCMS static placeholders
 */
export function removeQueryParams(query = {}) {
    const result = cloneDeep(query);

    IGNORED_QUERY_PARAMS.forEach((val) => {
        delete result[val];
    });

    return result;
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/router/env-helpers.js